import React from 'react'
import clsx from 'clsx'
import './Divider.scss'

export enum DividerOrientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
  Inline = 'inline',
}

export enum DividerSpacing {
  None = 'none',
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
}

export interface DividerProps {
  className?: string
  orientation?: DividerOrientation
  decorative?: boolean
  inversed?: boolean
  spacing?: DividerSpacing // only horizontal margin gap for inline divider
}

export const Divider: React.FC<DividerProps> = ({
  className,
  orientation = DividerOrientation.Horizontal,
  decorative = false,
  inversed = false,
  spacing = DividerSpacing.None,
}) => {
  const ariaOrientation = orientation === DividerOrientation.Inline ? undefined : orientation

  return (
    <div
      className={clsx('mk-divider', `mk-divider--${orientation}`, `mk-divider--spacing-${spacing}`, { 'mk-divider--inversed': inversed }, className)}
      role={decorative ? undefined : 'separator'}
      aria-orientation={decorative ? undefined : ariaOrientation}
      aria-hidden={decorative || undefined}
    />
  )
}
